
  import { defineComponent, PropType } from 'vue';

  import { getYearMonthWeekTree } from '@/common/utils/options';

  import FTSPeriodField from '../FTSPeriodField.vue';

  export default defineComponent({
    name: 'FTSWeeklyPeriodField',
    components: { FTSPeriodField },
    props: {
      modelValue: {
        type: Object as PropType<string[]>,
        required: true,
      },
      disabled: {
        type: Boolean,
      },
    },
    emits: ['update:modelValue'],
    computed: {
      periodAccessor: {
        get() {
          return this.modelValue;
        },
        set(newValue: string[]) {
          this.$emit('update:modelValue', newValue);
        },
      },
      getOptions() {
        return getYearMonthWeekTree(2001);
      },
    },
  });
